import { useQuery } from "@tanstack/react-query";
import { AuditTable } from "@/components/common/AuditTable";
import { ErrorState, LoadingState, PageHeader } from "@/components/common/States";
import { fetcher } from "@/lib/api";

export const AuditPage = ({ url, queryKey, eyebrow, description }) => {
  const q = useQuery({ queryKey: [queryKey], queryFn: () => fetcher(url) });
  return (
    <div>
      <PageHeader eyebrow={eyebrow} title="Log Audit" description={description} />
      {q.isLoading ? <LoadingState /> : q.error ? <ErrorState error={q.error} onRetry={q.refetch} /> : <AuditTable items={q.data} />}
    </div>
  );
};

export default function PlatformAudit() {
  return <AuditPage url="/platform/audit" queryKey="platform-audit" eyebrow="Pusat Kendali SIST"
    description="Catatan tambah-saja (append-only) untuk siklus hidup tenant, undangan, tinjauan identitas, dan sesi. Tidak dapat diubah atau dihapus." />;
}
